import { render, staticRenderFns } from "./create-customer-systemcode.vue?vue&type=template&id=3b79e67e"
import script from "./create-customer-systemcode.vue?vue&type=script&lang=ts"
export * from "./create-customer-systemcode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports